import { Box } from "@chakra-ui/layout";
import { type WithIdProps, withId } from "@components/HOC/with-id/withId";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import ProjectDetail from "@src/components/modules/projects/detail";
import { ProjectDetailForClient } from "@src/components/modules/projects/detail-for-client/ProjectDetailForClient";
import { NavigationProjects } from "@src/components/widgets/AppSubNav";
import { useStore } from "@src/utils/hooks";
import { createFileRoute } from "@tanstack/react-router";
import { observer } from "mobx-react-lite";

const Page = observer(function Page({ id }: WithIdProps) {
  const { authStore } = useStore();

  return (
    <MainLayout
      title={t`Project detail`}
      navigation={<NavigationProjects projectId={id} />}
      scrollToTopButton
      noBottomMargin={authStore.isInternalUser}
    >
      {authStore.isInternalUser ? (
        <Box pb="24">
          <ProjectDetail id={id} />
        </Box>
      ) : (
        <ProjectDetailForClient id={id} />
      )}
    </MainLayout>
  );
});

const RouteComponent = withId(Page);

export const Route = createFileRoute("/projects/detail")({
  component: RouteComponent,
});
